module.exports = __webpack_public_path__ + "static/media/tablet.463d1f92.svg";